import React, { memo, useEffect, useRef } from 'react'
import styled from 'styled-components'
import Chat from 'supportAssistant/components/Chat/Chat'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import useChats from 'supportAssistant/hooks/useChats'
import useChatListener from 'supportAssistant/hooks/useChatListeners'

const ScrollTo = styled.div`
  visibility: hidden;
`

function ChatPage() {
  useChatListener()
  useChats()

  const scrollRef = useRef<HTMLInputElement>(null)

  const scrollToBottom = () => {
    scrollRef.current?.scrollIntoView({ behavior: 'instant', inline: 'end' })
  }

  useEffect(() => {
    scrollToBottom()
  })

  return (
    <div>
      <CSSBreakpoint max="mobile">
        <ScrollTo ref={scrollRef} />
      </CSSBreakpoint>
      <Chat />
    </div>
  )
}

export default memo(ChatPage)
